import {EpicDependencies} from "../../models"

// Services
import AuthService from "../../modules/auth/services/AuthService"
import RecordsService from "../../modules/records/service/RecordsService"
import DoctorStatsService from "../../modules/doctor-stats/service/DoctorStatsService"
import createWSService from "../../modules/ws/services/WSService"

const authService = AuthService.init();

const Dependencies: EpicDependencies = {
    authService,
    wsService: createWSService(authService),
    recordsService: RecordsService,
    doctorStatsService: DoctorStatsService,
};

export default Dependencies
